const trimText = (value) => {
    if (typeof value !== "string") {
        return value;
    }
    const trimmed = value.trim();
    return trimmed || undefined;
};

const buildProfilePayload = (input = {}) => {
    const location = Array.isArray(input.city) ? input.city : [];
    const payload = {
        nickname: trimText(input.nickname),
        sex: input.sex === "" ? undefined : input.sex,
        province: trimText(location[0]),
        city: trimText(location[1] || (typeof input.city === "string" ? input.city : undefined)),
        area: trimText(location[2]),
        address: trimText(input.address),
        born: trimText(input.born),
        email: trimText(input.email),
        wechat: trimText(input.wechat),
        qq: trimText(input.qq),
        head: trimText(input.head) === "default" ? "default" : undefined,
    };

    return Object.keys(payload).reduce((result, key) => {
        if (payload[key] !== undefined) {
            result[key] = payload[key];
        }
        return result;
    }, {});
};

module.exports = { buildProfilePayload };
